import { i18n } from '@/plugins/translations/i18n'
import { setCurrentLanguage } from '@/plugins/translations/translation'
import { SupportedLocale } from '@/plugins/translations/types'
import store from '@/store'
import { computed } from '@vue/composition-api'

const useLocale = () => {

  const currentLocale = computed((): SupportedLocale => store.state.user.profile?.locale ?? i18n.locale as SupportedLocale)

  const setLocale = async (locale: SupportedLocale) => {
    setCurrentLanguage(locale)
    await store.dispatch.user.updateProfile({ locale })
  }

	return {
    currentLocale,
    setLocale
  }
}

export default useLocale
